export const updateExpectedDeliveryDate = (date) => {
  if (date) {
    const newDate = date + "000";

    return new Date(Number(newDate)).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  } else {
    return ' - '
  }
}

export const updateExpectedDeliveryDateNumberFormat = (date) => {
  if (date) {
    const newDate = new Date(Number(date + "000")); // Convert timestamp to Date object

    // Format date as DD-MM-YYYY
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const year = newDate.getFullYear();

    return `${day}-${month}-${year}`;
  } else {
    return ' - ';
  }
};
